var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolanaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5500_23121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24872 11.9636C3.36941 11.8429 3.53537 11.7725 3.71138 11.7725H19.6732C19.9648 11.7725 20.1107 12.1245 19.9045 12.3307L16.7514 15.4838C16.6307 15.6045 16.4647 15.6749 16.2887 15.6749H0.326917C0.0352396 15.6749 -0.110599 15.3229 0.0955866 15.1167L3.24872 11.9636Z",
    fill: "url(#paint0_linear_5500_23121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24872 0.191099C3.37444 0.0704048 3.54039 0 3.71138 0H19.6732C19.9648 0 20.1107 0.352024 19.9045 0.55821L16.7514 3.71134C16.6307 3.83203 16.4647 3.90244 16.2887 3.90244H0.326917C0.0352396 3.90244 -0.110599 3.55042 0.0955866 3.34423L3.24872 0.191099Z",
    fill: "url(#paint1_linear_5500_23121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7514 6.03973C16.6307 5.91904 16.4647 5.84863 16.2887 5.84863H0.326917C0.0352396 5.84863 -0.110599 6.20066 0.0955866 6.40684L3.24872 9.55997C3.36941 9.68067 3.53537 9.75107 3.71138 9.75107H19.6732C19.9648 9.75107 20.1107 9.39905 19.9045 9.19286L16.7514 6.03973Z",
    fill: "url(#paint2_linear_5500_23121)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5500_23121",
    x1: 18.1483,
    y1: -1.88383,
    x2: 7.10152,
    y2: 19.2753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5500_23121",
    x1: 13.3181,
    y1: -4.4054,
    x2: 2.27124,
    y2: 16.7537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5500_23121",
    x1: 15.7178,
    y1: -3.15252,
    x2: 4.671,
    y2: 18.0066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5500_23121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15.6751,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaLogo);
export default __webpack_public_path__ + "static/media/SolanaLogo.981465cbf0525276cea2427e5a770463.svg";
export { ForwardRef as ReactComponent };